import { Platform, StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";
const RADIUS = 74;
const style = ({ alignment }) => {
    const { borderRadiusFull, borderWidth2, colorBgBase, colorBorderActionSecondary, space4, space6 } = theme();
    return StyleSheet.create({
        button: {
            alignItems: "center",
            backgroundColor: colorBgBase,
            height: RADIUS,
            justifyContent: "center",
            paddingHorizontal: space6,
            width: RADIUS,
            ...Platform.select({
                android: {
                    borderColor: colorBorderActionSecondary,
                    borderRadius: borderRadiusFull,
                    borderWidth: borderWidth2,
                },
            }),
        },
        container: {
            alignItems: "center",
            flexDirection: "row",
        },
        svg: {
            height: RADIUS,
            position: "absolute",
            width: RADIUS,
            zIndex: 0,
        },
        text: {
            paddingHorizontal: space4,
            textAlign: alignment === "left" ? "right" : "left",
            textTransform: "uppercase",
        },
        textContainer: {
            left: alignment === "right" ? "100%" : undefined,
            position: "absolute",
            right: alignment === "left" ? "100%" : undefined,
            width: "100%",
        },
    });
};
export { style, RADIUS };
